/**
 * PBR Material Presets — physically-based rendering parameters
 * for MeshStandardMaterial. Each preset defines color, metalness,
 * roughness, and environment map intensity.
 */

export interface MaterialPreset {
  label: string;
  color: number;
  metalness: number;
  roughness: number;
  envMapIntensity: number;
}

export const MATERIAL_PRESETS: Record<string, MaterialPreset> = {
  default:    { label: "Default",    color: 0x4a8ed9, metalness: 0.15, roughness: 0.55, envMapIntensity: 0.4 },
  steel:      { label: "Steel",      color: 0xb0b0b8, metalness: 0.9,  roughness: 0.35, envMapIntensity: 1.0 },
  aluminum:   { label: "Aluminum",   color: 0xd0d0d8, metalness: 0.85, roughness: 0.3,  envMapIntensity: 0.9 },
  brass:      { label: "Brass",      color: 0xc8a830, metalness: 0.9,  roughness: 0.25, envMapIntensity: 1.0 },
  copper:     { label: "Copper",     color: 0xc07040, metalness: 0.9,  roughness: 0.3,  envMapIntensity: 0.9 },
  titanium:   { label: "Titanium",   color: 0x888898, metalness: 0.8,  roughness: 0.4,  envMapIntensity: 0.8 },
  plastic:    { label: "Plastic",    color: 0xe8e8e8, metalness: 0.0,  roughness: 0.6,  envMapIntensity: 0.3 },
  "abs-black":{ label: "ABS Black",  color: 0x202020, metalness: 0.0,  roughness: 0.5,  envMapIntensity: 0.2 },
  rubber:     { label: "Rubber",     color: 0x303030, metalness: 0.0,  roughness: 0.95, envMapIntensity: 0.1 },
  glass:      { label: "Glass",      color: 0xd0e8f0, metalness: 0.1,  roughness: 0.05, envMapIntensity: 1.2 },
  wood:       { label: "Wood",       color: 0xa07040, metalness: 0.0,  roughness: 0.8,  envMapIntensity: 0.2 },
  gold:       { label: "Gold",       color: 0xd4a840, metalness: 0.95, roughness: 0.15, envMapIntensity: 1.2 },
};

export const PRESET_KEYS = Object.keys(MATERIAL_PRESETS);
